import { Box, Link, Stack, Text, Icons, palette } from '@solvhealth/jigsaw-v1';
import React from 'react';
import { AlmaUrls } from '~/components/AccountGetsMarried/constants/alma';
import { NativeFunctions } from '~/core/util/native';
import CheckIcon from '~/components/PhotoIdUpload/components/CheckIcon';

const InsuranceName = ({ name }: { name: string }) => {
  return (
    <Stack alignItems="center" row space={1}>
      <CheckIcon />
      <Text muted>{name}</Text>
    </Stack>
  );
};

export function AlmaInsurance() {
  return (
    <Stack id="insurance" px={3} space={1}>
      <Text variant="h3">Accepted insurance</Text>
      <Text muted>
        <p>
          To see if your insurance is accepted, how much your insurance covers, and what you’ll owe
          per session, use{' '}
          <Link
            contentProps={{
              style: {
                wordWrap: 'break-word',
                wordBreak: 'break-word',
                display: 'inline',
              },
            }}
            external
            href={AlmaUrls.costEstimator}
            onClick={(e: any) => {
              if (NativeFunctions.openNativeUrl.exists) {
                e.preventDefault();
                NativeFunctions.openNativeUrl.call(AlmaUrls.costEstimator);
              }
            }}
            openInNewWindow
            sx={{
              wordWrap: 'break-word',
              wordBreak: 'break-word',
              display: 'inline',
            }}
          >
            Alma’s cost estimator
          </Link>
          . Most therapists at Alma accept insurance from the following major insurance companies:
        </p>
        <p>
          <Stack row space={8}>
            <Stack space={1}>
              <InsuranceName name="Anthem" />
              <InsuranceName name="Cigna" />
              <InsuranceName name="United" />
            </Stack>
            <Stack space={1}>
              <InsuranceName name="Aetna" />
              <InsuranceName name="Optum" />
            </Stack>
          </Stack>
        </p>
        <p>
          Alma therapists are NOT currently in-network with Medicare, Medicaid, and most of the
          “Blue” insurance carriers.
        </p>
        <p>
          Out-of-pocket options are also available, including sliding scale rates based on your
          income.
        </p>
      </Text>
    </Stack>
  );
}
